import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import { camelCase } from 'lodash'
import LUIS_API_URL from 'utils/LuisApiUrl'

export const getPredictionv2 =
	(utterance, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.PREDICTIONS.GET_REQUEST,
			...argObject,
		})
		if (!utterance || !camelCase(utterance)) return Promise.resolve()
		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${LUIS_API_URL}utterance=${utterance}`, {
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					headers: {
						'content-type': 'application/json',
						authorization: headerValue,
					},
					method: 'GET', // *GET, POST, PUT, DELETE, etc.
					mode: 'cors', // no-cors, cors, *same-origin
					redirect: 'follow', // manual, *follow, error
					referrer: 'no-referrer', // *client, no-referrer
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then((payload) =>
						payload && payload.notOk
							? dispatch({
									type: ActionType.PREDICTIONS.GET_FAILURE,
									payload,
									...argObject,
							  })
							: dispatch({
									type: ActionType.PREDICTIONS.GET_SUCCESS,
									payload,
									...argObject,
							  }),
					)
					.catch((error) =>
						dispatch({
							type: ActionType.PREDICTIONS.GET_FAILURE,
							payload: error,
							...argObject,
						}),
					)
			})
			.catch((err) => {
				console.log(err)
			})
	}

export const consumePrediction =
	(intent, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.PREDICTIONS.CONSUME_PREDICTION,
			intent,
			...argObject,
		})
		return Promise.resolve()
	}

export const ingestPrediction =
	(payload, intent, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.PREDICTIONS.INGEST_PREDICTION,
			payload,
			intent,
			...argObject,
		})
		return Promise.resolve()
	}
